import script from "./continuous-order-list.vue?vue&type=script&lang=tsx&setup=true"
export * from "./continuous-order-list.vue?vue&type=script&lang=tsx&setup=true"

const __exports__ = script;

export default __exports__